export const memberTypeOptions = [
  { value: "", text: "ทั้งหมด" },
  { value: "Distributor", text: "นักธุรกิจ" },
  { value: "Member", text: "VIP MEMBER" },
];
